import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { ProfileSectionTool } from '../../../../../viewer/tools/profile-section-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

export const ProfileSectionToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);
  const isActive = useMemo(() => activeTool instanceof ProfileSectionTool, [activeTool]);

  return (
    <ToolIcon
      active={isActive}
      callback={() => {
        if (!InputHandler.instance.isOrthophotoComparisonToolActive()) {
          InputHandler.instance.setTool('profile-section');
        }
      }}
      icon={['fal', 'chart-area']}
      tooltip={{
        title: t('profileSection.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('profileSection.tooltip.info', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};
